import React, { FC } from 'react';
import classNames from 'classnames';

interface IProps {
  text: string;
  actionHandler: () => void;
  setShouldShowEllipsisMenu: (value: boolean) => void;
  icon?: string;
  customClassName?: string;
  isHidden?: boolean;
  isDisabled?: boolean;
}

const PollEllipsisMenuItem: FC<IProps> = ({ text, icon, actionHandler, setShouldShowEllipsisMenu, isHidden, isDisabled }) => {
  const actionHandlerWrapper = () => {
    actionHandler();
    setShouldShowEllipsisMenu(false);
  };

  return (
    <div
      className={classNames('poll-ellipsis-menu-item', {
        'disabled': isDisabled,
        'hidden': isHidden
      })}
      onClick={actionHandlerWrapper}
    >
      {icon && <img src={icon} alt={`${text} icon`}/>}
      <span>{text}</span>
    </div>
  );
};

export { PollEllipsisMenuItem };
